
import { defineComponent } from "vue";

export default defineComponent({
  name: "ReceiverStatsDisplayCard",
  props: [
      'label',
      'title',
      'counters'
  ]
})
